import type { Variants } from "motion/react";

/**
 * Shared landing-page motion tokens. Kept in a non-component module so the
 * component files stay Fast-Refresh-clean (a file may not export both a
 * component and constants).
 *
 * Dampened ease-out only — institutional brand, no bounce/elastic (sked-design
 * "no bouncy animation"). EASE mirrors the CSS --ts-ease-out token
 * (cubic-bezier(0.2, 0, 0, 1)).
 */
export const EASE = [0.2, 0, 0, 1] as const;
export const REVEAL_DURATION = 0.5;

/** Parent that staggers any variant children into view. Pair with `staggerItem`. */
export const staggerContainer: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
};

/** A single staggered child (rise + fade). Pair with `staggerContainer`. */
export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: REVEAL_DURATION, ease: EASE } },
};
